import React from "react";

export default function Hardware() {
  return (
    <svg
      width="480"
      height="480"
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Hardware">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M160 176H48C43.582 176 40 179.582 40 184V248C40 252.418 43.582 256 48 256H160C164.418 256 168 252.418 168 248V184C168 179.582 164.418 176 160 176ZM152 240H56V192H152V240Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path id="Vector_2" d="M232 176H216V192H232V176Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path id="Vector_3" d="M312 176H248V192H312V176Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <path id="Vector_4" d="M312 208H184V224H312V208Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_9">
          <g id="Group_10">
            <path id="Vector_5" d="M280 240H184V256H280V240Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_11">
          <g id="Group_12">
            <path id="Vector_6" d="M312 272H40V288H312V272Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_13">
          <g id="Group_14">
            <path id="Vector_7" d="M280 304H40V320H280V304Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_15">
          <g id="Group_16">
            <path
              id="Vector_8"
              d="M448 0H160C142.327 0 128 14.327 128 32V136H32C14.327 136 0 150.327 0 168V376C0 393.673 14.327 408 32 408H126.24L121.44 432H104C90.745 432 80 442.745 80 456C80 469.255 90.745 480 104 480H248C261.255 480 272 469.255 272 456C272 442.745 261.255 432 248 432H230.56L225.76 408H320C337.673 408 352 393.673 352 376V272H448C465.673 272 480 257.673 480 240V32C480 14.327 465.673 0 448 0ZM248 448C252.418 448 256 451.582 256 456C256 460.418 252.418 464 248 464H104C99.582 464 96 460.418 96 456C96 451.582 99.582 448 104 448H248ZM137.76 432L142.56 408H209.44L214.24 432H137.76ZM336 376C336 384.837 328.837 392 320 392H32C23.163 392 16 384.837 16 376V360H336V376ZM336 344H16V168C16 159.163 23.163 152 32 152H320C328.837 152 336 159.163 336 168V344ZM464 240C464 248.837 456.837 256 448 256H352V224H464V240ZM464 208H352V168C352 150.327 337.673 136 320 136H144V32C144 23.163 151.163 16 160 16H448C456.837 16 464 23.163 464 32V208Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_17">
          <g id="Group_18">
            <path
              id="Vector_9"
              d="M288 40H176C171.582 40 168 43.582 168 48V112C168 116.418 171.582 120 176 120H288C292.418 120 296 116.418 296 112V48C296 43.582 292.418 40 288 40ZM280 104H184V56H280V104Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_19">
          <g id="Group_20">
            <path id="Vector_10" d="M360 40H344V56H360V40Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_21">
          <g id="Group_22">
            <path id="Vector_11" d="M440 40H376V56H440V40Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_23">
          <g id="Group_24">
            <path id="Vector_12" d="M440 72H312V88H440V72Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_25">
          <g id="Group_26">
            <path id="Vector_13" d="M408 104H312V120H408V104Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_27">
          <g id="Group_28">
            <path id="Vector_14" d="M440 136H376V152H440V136Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_29">
          <g id="Group_30">
            <path id="Vector_15" d="M408 168H376V184H408V168Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_31">
          <g id="Group_32">
            <path id="Vector_16" d="M448 288H432V304H448V288Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_33">
          <g id="Group_34">
            <path id="Vector_17" d="M448 320H432V336H448V320Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_35">
          <g id="Group_36">
            <path id="Vector_18" d="M448 352H432V368H448V352Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_37">
          <g id="Group_38">
            <path id="Vector_19" d="M416 352H400V368H416V352Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_39">
          <g id="Group_40">
            <path id="Vector_20" d="M384 352H368V368H384V352Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_41">
          <g id="Group_42">
            <path id="Vector_21" d="M48 104H32V120H48V104Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_43">
          <g id="Group_44">
            <path id="Vector_22" d="M48 72H32V88H48V72Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_45">
          <g id="Group_46">
            <path id="Vector_23" d="M48 40H32V56H48V40Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_47">
          <g id="Group_48">
            <path id="Vector_24" d="M80 40H64V56H80V40Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_49">
          <g id="Group_50">
            <path id="Vector_25" d="M112 40H96V56H112V40Z" fill="#242424" />
          </g>
        </g>
      </g>
    </svg>
  );
}
